import { useMemo } from 'react'
import { PecPage } from './PecPage'
import { createPecDashboardStore } from './stores/pecDashboardStore'

/**
 * @fileoverview PEC Page Container
 *
 * Container component that initializes the dashboard store
 */

export const PecPageContainer = () => {
	const store = useMemo(() => createPecDashboardStore(), [])

	return <PecPage store={store} />
}
